import { render, staticRenderFns } from "./AgeRanges.vue?vue&type=template&id=382df686&"
import script from "./AgeRanges.vue?vue&type=script&lang=js&"
export * from "./AgeRanges.vue?vue&type=script&lang=js&"
import style0 from "./AgeRanges.vue?vue&type=style&index=0&id=382df686&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('382df686')) {
      api.createRecord('382df686', component.options)
    } else {
      api.reload('382df686', component.options)
    }
    module.hot.accept("./AgeRanges.vue?vue&type=template&id=382df686&", function () {
      api.rerender('382df686', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/AgeRanges.vue"
export default component.exports